module.exports = __webpack_public_path__ + "img/logo.5265f436.png";